import Mixin from '../../utils/mixin'
import { i18n } from '../../plugins/i18n'
const loadState = () => ({
    fileboxLoaded: false,
    fileboxList: [],
    fileboxTrash: [],
    currentFolderId: null,
});
export default {
    namespaced: true,
    state: loadState(),
    getters: {
        fileboxLoaded(state){
            return state.fileboxLoaded
        },
        getFileboxList(state){
            return state.fileboxList
        },
        getFileboxTrash(state){
            return state.fileboxTrash
        },
        getCurrentFolderId(state) {
            return state.currentFolderId
        }
    },
    mutations: {
        setSelectFolder(state, folder_id) {
            state.currentFolderId = folder_id;
        },
        setFileboxList(state, data){
            state.fileboxLoaded = true;
            state.fileboxList = data;
        },
        setFileboxTrash(state, data){
            state.fileboxLoaded = true;
            state.fileboxTrash = data;
        },
        resetFilebox(state){
            state.fileboxLoaded = false
            state.fileboxList = [];            
        }
    },
    actions: {
        async fetchFileboxList({commit,getters}, {folder_id}){

            // console.log('fetchFileboxList folder_id', folder_id);
            
            if(this.getters['auth/isAuthenticated']){
                const res = await Mixin.methods.call_api("post", `user/filebox`, {
                    'folder_id': folder_id,
                });
                if(res.data.success){
                    commit('setFileboxList',res.data);
                }
            }
        },

        async fetchFileboxTrash({commit,getters}){
            
            if(this.getters['auth/isAuthenticated']){
                const res = await Mixin.methods.call_api("get", `user/filebox/trash`);
                if(res.data.success){
                    commit('setFileboxTrash',res.data);
                }
            }
        },
        resetFilebox({commit}){
            commit('resetFilebox')
        }
    }
}